<template>
  <div>
    <OrderTable
      :id="`open-orders`"
      :orders="open_orders"
      :meta="open_orders_meta"
      :loading="loading"
      @updateOrderTable="getOpenOrders()"
    />
  </div>
</template>

<script>
import OrderTable from '../_OrderTable.vue';

export default {
  components: {
    OrderTable,
  },
  data() {
    return {
      open_orders: [],
      open_orders_meta: {
        total: 0,
      },

      filters: {
        orderBy: 'created_at',
        orderDirection: 'desc',
      },

      loading: false,
    };
  },
  methods: {
    filter() {
      this.$root.applyFilters(this.filters);
      this.getOpenOrders();
    },

    getOpenOrders() {
      this.loading = true;

      let statuses = `${this.$root.OrderStatus.PROCESSING},${this.$root.OrderStatus.SAMPLE_PROCESSING}`;

      let params = {
        ...this.filters,
        customer: this.$route.params.id,
        status: statuses,
        page: this.$route.query.page ? this.$route.query.page : null,
      };

      this.$http
        .get(`orders`, {
          params: params,
        })
        .then((response) => {
          this.open_orders = response.data.data;
          this.open_orders_meta = response.data.meta;

          this.loading = false;
        });
    },
  },
  mounted() {
    this.filters = this.$root.setFilters(this.filters);
    this.getOpenOrders();
  },
};
</script>
